import { CapacitorUpdater } from "@capgo/capacitor-updater";

/**
 * Tells @capgo/capacitor-updater that this bundle booted far enough to be trusted.
 *
 * This must be the *first* thing index.tsx imports. If the call does not happen within
 * `appReadyTimeout` (10s by default; not overridden in capacitor.config.ts) the native
 * layer reverts to the previously installed bundle. That turns any module-scope throw in
 * a module evaluated ahead of it into a silent rollback on every device that took the
 * update — the app appears to downgrade itself over the network.
 *
 * It previously sat at module scope in appStateListener.ts, which index.tsx imported
 * *after* `./App`, `./data/apiClients` and `./data/interseptors`, all of which run
 * module-scope code. `apiClients.ts` in particular constructs two ApiClients at import
 * time, and did throw during this upgrade. The plugin's own docs are explicit: call it in
 * the entry point, before anything else, and not behind conditions.
 *
 * It is a side-effect-only module so that import order alone guarantees it runs first —
 * ESM hoists imports, so a bare statement at the top of index.tsx would still run after
 * every import in that file.
 */
try {
  // Documented to always resolve, but on web the plugin has no implementation, so the
  // Capacitor proxy can still throw synchronously or reject. Neither should stop boot,
  // and neither should surface as an unhandled rejection.
  void CapacitorUpdater.notifyAppReady().catch((error) => {
    console.warn("notifyAppReady rejected:", error);
  });
} catch (error) {
  console.warn("notifyAppReady not available:", error);
}
